<template>
  <div>
    <Top></Top>
    <div class="main">
      <!-- 头部 -->
      <div class="head">
        <div>
          <div class="logo fl">
            <router-link to="/">
              www.rakumart-2c.com
            </router-link>
          </div>
          <h2>支払い完了画面</h2>
        </div>
      </div>
      <div class="content">
        <div class="fl img">
          <img src="../../assets/img/pay_ok.png" alt />
        </div>
        <div class="fl txt">
          <h3>
            支払い完了いたしました、残高反映とともに買い付けを実行致します。
            よろしくお願いします。
          </h3>
          <p>
            支払い額：
            <span>{{ $route.query.orderPrice }}</span> 円
          </p>
          <p style="margin-bottom: 50px">支払い番号：{{ $route.query.data }}</p>
          <router-link to="/">トップページへ</router-link>
          <router-link to="/user/index">マイページへ</router-link>
          <router-link to="/user/golden">残高照会へ</router-link>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {};
  },
  components: {
    Top,
    Foot,
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto 50px;

  .head {
    margin-top: 20px;
    overflow: hidden;
    margin-bottom: 30px;

    .logo {

      height: 100px;
      margin-bottom: 20px;
      overflow: hidden;

      a {
        color: #f3c622;
        font-size: 30px;
        line-height: 100px;
      }

      img {
        height: 100%;
      }
    }

    h2 {
      float: left;
      font-size: 30px;
      margin: 30px 0 0 40px;
    }
  }

  .content {
    overflow: hidden;
    border: 2px solid #333;
    border-radius: 20px;
    padding: 100px 0px 80px 230px;

    .img {
      width: 96px;
      height: 96px;
      margin-right: 40px;

      img {
        width: 96px;
        height: 96px;
      }
    }

    .txt {
      width: 822px;
      font-size: 25px;
      line-height: 50px;

      h3 {
        margin-bottom: 30px;
      }

      p {
        span {
          color: #F3C622;
        }
      }

      a {
        margin: 0 20px;
        color: #333;

        &:hover {
          color: #F3C622;
        }
      }
    }
  }
}
</style>